<template>
  <div>
    <b-modal id="modalDownloadFbl" centered hide-footer>
      <template #modal-header="{ hide }">
        <div class="title-custom">Download FBL</div>
        <div class="close" @click="hide()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M0.77002 0.886719L13 13.1167" stroke="white" stroke-width="2"/>
            <path d="M12.2803 0.886719L0.77002 13.1167" stroke="white" stroke-width="2"/>
          </svg>
        </div>
      </template>
      <template v-if="fiataStatus && fiataStatus.length > 0">
        <div class="pb-3">
          <table class="table">
            <thead style="color: #9EA1A4;">
              <th class="p-3">File Name</th>
              <th class="p-3">Action</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in fiataStatus" :key="index">
                <td class="text-blue">{{ item.bl_id }}</td>
                <td>
                  <button class="button__bluesmall" @click="downloadFbl(item.id)">
                    <span v-if="isLoadingDownloadEfbl">
                      <b-spinner small variant="light" label="Loading..." />
                    </span>
                    <span v-else>
                      Download FBL
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="py-4 bg-white w-full d-flex align-items-center justify-content-center">
          <p class="text-sm font-italic">No FBL Available</p>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'DownloadFbl',
  props: {
    fiataStatus: {
      type: Array,
      default: () => []
    },
    orderNumber: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({      
      isLoadingDownloadEfbl: 'shipment/isLoadingDownloadEfbl',
      errorDownloadEfbl: 'shipment/errorDownloadEfbl'
    })
  },
  methods: {
    async downloadFbl (shipmentFiataId) {
      const dateTime = moment(new Date()).format('L h:mm')
      const orderNumber = this.orderNumber.split('/').join('-')
      await this.$store.dispatch('shipment/DOWNLOAD_EFBL', {
        shipmentFiataId,
        fileName: `FBL-${shipmentFiataId}-${orderNumber}-${dateTime}.pdf`
      }).then(() => {
        if (this.errorDownloadEfbl) {
          this.$eventHub.$emit('dialog-result-action', {
            title: 'Error',
            message: 'Failed to download',
            status: 'failed'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/DownloadFbl.vue